
import Component from 'flarum/Component'
import humanTime from 'flarum/utils/humanTime'

// import FlagList from './FlagList';

/**
 * The `FlagsPage` component shows the flags list. It is only
 * used on mobile devices where the flags dropdown is within the drawer.
 */
export default class FlagsPage extends Component {
  oninit (vnode) {
    super.oninit(vnode)

    // app.history.push('news');

    app.news.load()

  }

  view () {
    const cache = app.news.cache
    if (cache === undefined) return null
    const bigLength = (cache || cache.length > 2)
    let newsList = []
    cache.map(news => {
      newsList.push(
        m('li.as-news-list', {
          key: news.id(),
          'data-id': news.id()
        }, m('.News-card.position-relative', [
          m('img.card-img', {
            src: news.imageUrl()
          }),
          m('.card-title', news.title()),
          m('.card-date', ''),
          // m('.card-date', humanTime(news.createdAt())),
          // m('.card-abstract', news.abstract()),
          m('a.stretched-link[target="_blank"]', {
            href: news.link()
          })
        ]))
      )
    })
    const cW = document.documentElement.clientWidth
    const phonePoint = 767
    const showBtn = cW >= phonePoint
    return (
      <div class="NewsBox">
        <div class="News-title">Featured Threads</div>
        <ul class="News-ul">
          {
            newsList
          }
        </ul>
        {
          bigLength && showBtn ? 
          <div class="news-btn">
            <button class="Button Button--primary IndexPage-newDiscussion as-news-btn" type="button" title="Show more" onclick={this.showmore.bind(this)}>
              <span class="Button-label">Show more</span>
            </button>
          </div>
          :
          null
        }
      </div>
    )
  }

  showmore() {
    const $dom = document.querySelectorAll('.as-news-list')
    const $btn = document.querySelector('.as-news-btn')
    Array.from($dom).map(val => {
      val.classList.add('active')
    })
    // console.log(this)
    $btn.remove()
  }

}
